<template>
  <router-view/>
</template>

<style>

body, html {
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* Esconde a barra de rolagem horizontal */
  width: 100%;
  box-sizing: border-box; /* Inclui bordas e paddings no cálculo do tamanho do elemento */
}
    
</style>
